module.exports = __webpack_public_path__ + "media/customizations/onvie/logo-new-9bcc212bb887536b4cf1f43a521af63b.png";